angular.module('TetherApp').directive('tetherCheckbox', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherCheckbox.html'
    }
});
